// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2vst0","row":"ProcedureTreatmentSummary_row__qltxF"};